import { useState } from "react";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Alert, Button, Stack } from "@mui/material";
import AddLocationAltOutlinedIcon from "@mui/icons-material/AddLocationAltOutlined";
import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { ApiCourseRequest } from "data/queries/ApiCourse";
import { CustomRendererProps } from "../types";
import { unitAddressValues } from "layouts/aplicacoes/Events/hooks/unitAddressUtils";

const QUERY = print(gql`
  query EventResponsibleUnitAddress($id: Int!) {
    EducationalUnit(id: $id) {
      id name visibleName active addressString street number complement neighborhood city state postalCode
    }
  }
`);

function Renderer({ data, handleChange, path, enabled = true }: CustomRendererProps<any>) {
  const unitId = Number(data?.educationalUnitId || 0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fillAddress = () => {
    if (!unitId) return;
    setError("");
    setLoading(true);
    ApiCourseRequest<any>({ query: QUERY, variables: { id: unitId } })
      .then((response) => {
        const unit = response.data.data?.EducationalUnit;
        if (!unit?.active) throw new Error("A unidade selecionada não está ativa.");
        const address = unitAddressValues(unit);
        handleChange(path, { ...data, address });
      })
      .catch((reason) => {
        setError(reason?.message || "Não foi possível carregar o endereço da unidade.");
      })
      .finally(() => setLoading(false));
  };

  return <Stack justifyContent="center" sx={{ pt: 1.25, minWidth: 180 }}>
    <Button
      variant="contained"
      color="info"
      size="small"
      fullWidth
      startIcon={<AddLocationAltOutlinedIcon />}
      disabled={!unitId || loading || enabled === false}
      onClick={fillAddress}
      sx={{ minHeight: 38, px: 1.5, whiteSpace: "nowrap", fontSize: "0.72rem" }}
    >
      {loading ? "Carregando..." : "Preencher endereço"}
    </Button>
    {!unitId && <Alert severity="info" sx={{ mt: 1, py: 0 }}>Selecione a unidade.</Alert>}
    {error && <Alert severity="warning">{error}</Alert>}
  </Stack>;
}

export default withJsonFormsControlProps(Renderer);
